/**
 * Created by Administrator on 2020/4/23.
 */
import Vue from 'vue'
export default new Vue()